// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__3xMtx","buttons":"PendingPaymentAlert_buttons__2Zb4C"};